import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";
import {
  getOrderStatusDefinition,
  toOrderStatus,
  type OrderStatusColorToken,
} from "@nexus/order-status";

export type OrderStatusTone = OrderStatusColorToken | "neutral";

export interface OrderStatusVisual {
  tone: OrderStatusTone;
  dotClass: string;
  pillClass: string;
  segmentClass: string;
}

const TONE_VISUAL: Record<OrderStatusTone, Omit<OrderStatusVisual, "tone">> = {
  neutral: {
    dotClass: "bg-muted-foreground",
    pillClass: "bg-slate-chip-bg text-slate-chip-text",
    segmentClass: "bg-muted-foreground/55",
  },
  info: {
    dotClass: "bg-info",
    pillClass: "bg-info-subtle text-info-subtle-foreground",
    segmentClass: "bg-info",
  },
  primary: {
    dotClass: "bg-primary",
    pillClass: "bg-primary-subtle text-primary",
    segmentClass: "bg-primary",
  },
  danger: {
    dotClass: "bg-error",
    pillClass: "bg-error-subtle text-error-subtle-foreground",
    segmentClass: "bg-error",
  },
  warning: {
    dotClass: "bg-warning",
    pillClass: "bg-warning-subtle text-warning-subtle-foreground",
    segmentClass: "bg-warning",
  },
  success: {
    dotClass: "bg-success",
    pillClass: "bg-success-subtle text-success-subtle-foreground",
    segmentClass: "bg-success",
  },
};

/** Status hue is pipeline stage only; time urgency stays on the error/warning time tokens. */
export function getOrderStatusVisual(
  status: MarketplaceFulfillmentStatus,
): OrderStatusVisual {
  const tone =
    status === "SCRIPT"
      ? "neutral"
      : getOrderStatusDefinition(toOrderStatus(status)).colorToken;
  return { tone, ...TONE_VISUAL[tone] };
}
